module.exports = __webpack_public_path__ + "a768e7de/img/file-icon.c085e21e.svg";